import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    id: "s1",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20an%20astronaut%20silhouette%20before%20a%20vast%20glowing%20planet%2C%20deep%20blue%20space%20with%20warm%20orange%20nebula%20lights%2C%20dramatic%20atmospheric%20scale%2C%20empty%20left%20space%20for%20text%20overlay%2C%20professional%20film%20key%20art&width=1600&height=900&seq=hero-slide-1&orientation=landscape",
    eyebrow: "星光影业 · 科幻巨制",
    title: "星际回响",
    desc: "当人类收到来自四光年之外的信号，一段关于希望与连接的深空之旅就此展开。",
    tags: ["科幻", "冒险", "视效大片"],
    to: "/detail/film/m2",
  },
  {
    id: "s2",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20in%20falling%20snow%2C%20deep%20blue%20cold%20light%20with%20warm%20lantern%20glow%2C%20dramatic%20historical%20atmosphere%2C%20empty%20space%20for%20text%20overlay%2C%20professional%20key%20art&width=1600&height=900&seq=hero-slide-2&orientation=landscape",
    eyebrow: "星光影业 · 历史大剧",
    title: "长夜将明",
    desc: "乱世之中，一位寒门书生走入庙堂，要在权谋与家国之间守住心中那盏不灭的灯。",
    tags: ["历史", "权谋", "古装"],
    to: "/detail/film/tv1",
  },
  {
    id: "s3",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20singer%20silhouette%20on%20a%20dramatic%20spotlit%20stage%2C%20vivid%20warm%20orange%20spotlight%20against%20deep%20blue%20darkness%2C%20high%20energy%20concert%20atmosphere%2C%20empty%20space%20for%20text%20overlay%2C%20professional%20key%20art&width=1600&height=900&seq=hero-slide-3&orientation=landscape",
    eyebrow: "星光传媒 · 音乐竞演",
    title: "声动未来",
    desc: "顶尖歌手同台竞演，用声音讲述故事，用舞台点燃情感，一起聆听未来的回响。",
    tags: ["音乐", "竞演", "高燃"],
    to: "/detail/film/v2",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    if (paused) return;
    timer.current = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, [paused]);

  const go = (next: number) => setIndex((next + slides.length) % slides.length);

  return (
    <section
      className="relative h-[480px] w-full overflow-hidden bg-primary-950 md:h-[600px] lg:h-[680px]"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点图`}
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/30" />
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1280px] items-center px-4 md:px-6">
        <div key={index} className="w-full max-w-xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-300 backdrop-blur-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            {slides[index].eyebrow}
          </span>
          <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
            {slides[index].title}
          </h1>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200 md:text-base">
            {slides[index].desc}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {slides[index].tags.map((tag) => (
              <span
                key={tag}
                className="rounded-md bg-background-50/10 px-2.5 py-1 text-xs text-background-100 backdrop-blur-sm"
              >
                {tag}
              </span>
            ))}
          </div>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to={slides[index].to}
              className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              查看详情
            </Link>
            <Link
              to="/category/movie"
              className="whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/5 px-5 py-2.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/15"
            >
              浏览全部作品
            </Link>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="absolute bottom-6 left-0 right-0 z-10 mx-auto flex max-w-[1280px] items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第${i + 1}张`}
              onClick={() => go(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-8 bg-accent-500" : "w-4 bg-background-50/40 hover:bg-background-50/70"
              }`}
            />
          ))}
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            aria-label="上一张"
            onClick={() => go(index - 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 backdrop-blur-sm transition-colors hover:bg-accent-500"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={() => go(index + 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 backdrop-blur-sm transition-colors hover:bg-accent-500"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>
      </div>
    </section>
  );
}